import React from 'react';
import styles from './ListErrors.module.scss';

export const ListErrors = ({ errors }: Props) => {
    if (errors.length === 0) {
        return null;
    } else if (errors.length === 1) {
        return (
            <>{errors[0]}</>
        );
    } else {
        return (
            <ul className={styles.list}>
                {errors.map((error, index) => (
                    <li key={index}> {error}</li>
                ))}
            </ul>
        );
    }
};

type Props = {
    errors: string[];
};